import { DataSource } from "@angular/cdk/collections";
import { C } from "@angular/cdk/data-source.d-Bblv7Zvh";
import { BehaviorSubject, Observable } from "rxjs";
import { CaseSearchService } from "src/app/_services/incident/case-search/case-search.service";
import { WfdssCaseSearchDTO } from "src/app/_types/wfdss-case-search-dto";
import { ICaseAdvancedSearchParams, ICaseAdvancedSearchFilters } from "./wfdss-case-search-report.component";
import { map, take, tap } from "rxjs/operators";

export class CaseSearchDataSource implements DataSource<WfdssCaseSearchDTO>{
    _cases = new BehaviorSubject<WfdssCaseSearchDTO[]>([])
    _loading = new BehaviorSubject<boolean>(false)
    _page = new BehaviorSubject<any>(null)
    page$ = this._page.asObservable()
    private _params = new BehaviorSubject<ICaseAdvancedSearchParams>(null)
    private _filters = new BehaviorSubject<ICaseAdvancedSearchFilters>(null)
    constructor(
        private caseSearchSvc: CaseSearchService, 
        private defaultFilters: ICaseAdvancedSearchFilters, 
        private defaultParams: ICaseAdvancedSearchParams){
            this._filters.next(this.defaultFilters)
            this._params.next(this.defaultParams)
        }
    connect(collectionViewer: C): Observable<readonly WfdssCaseSearchDTO[]> {
        return this._cases.asObservable()
    }
    disconnect(collectionViewer: C): void {
        this._cases.complete()
        this._loading.complete()
    }
    onSearch(filters: ICaseAdvancedSearchFilters, params: ICaseAdvancedSearchParams){
        this._filters.next(filters)
        this._params.next(params)
        this.caseSearchSvc.getCasesByAdvancedSearch(filters, params).pipe(
            take(1),
            tap((results)=>{
                this._cases.next(results.content)
                this._page.next(results.totalElements)
            })
        ).subscribe(()=>{})
    }
    onPageOrSortChange(params: ICaseAdvancedSearchParams){
        this._params.next(params)
        let filters = this._filters.value
        this.caseSearchSvc.getCasesByAdvancedSearch(filters, params, true).pipe(
            take(1),
            tap((results)=>{
                this._cases.next(results.content)
            })
        ).subscribe(()=>{})
    }
    loadCasesForDownload(){
        let filters = this._filters.value 
        let params = Object.assign({},this._params.value)
        params.limit = 10000
        params.offset = 0
        return this.caseSearchSvc.getCasesByAdvancedSearch(filters, params).pipe(
            take(1),
            map((cases)=>{
                return cases.content
            })
        )
    }
}